// extracted by mini-css-extract-plugin
export default {"wrapper":"CheckboxList_wrapper__t2VOM","checkboxList":"CheckboxList_checkboxList__UPrL-","checkbox":"CheckboxList_checkbox__SjMvo"};